import React from 'react';
import { Swiper as SwiperComponent, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay, EffectCoverflow } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import clsx from 'clsx';

interface SwiperProps {
  children: React.ReactNode[];
  className?: string;
  slidesPerView?: number;
  spaceBetween?: number;
  autoplay?: boolean;
}

export function Swiper({
  children,
  className,
  slidesPerView = 4,
  spaceBetween = 30,
  autoplay = true,
}: SwiperProps) {
  return (
    <div className="swiper-container relative group">
      <button className="hidden md:block swiper-button-prev !hidden group-hover:!flex absolute left-0 top-1/2 -translate-y-1/2 -translate-x-full z-10 w-12 h-12 bg-dark/80 hover:bg-dark text-light rounded-full items-center justify-center">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="m15 18-6-6 6-6"/>
        </svg>
      </button>

      <button className="hidden md:block swiper-button-next !hidden group-hover:!flex absolute right-0 top-1/2 -translate-y-1/2 translate-x-full z-10 w-12 h-12 bg-dark/80 hover:bg-dark text-light rounded-full items-center justify-center">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="m9 18 6-6-6-6"/>
        </svg>
      </button>

      <SwiperComponent
        modules={[Navigation, Autoplay, EffectCoverflow]}
        spaceBetween={spaceBetween}
        slidesPerView={1.2}
        effect={'coverflow'}
        grabCursor={true}
        centeredSlides={true}
        coverflowEffect={{
            rotate: 0,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: false,
        }}
        navigation={{
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next',
        }}
        loop={true}
        autoplay={autoplay ? { delay: 5000, disableOnInteraction: false } : false}
        className={clsx('w-full overflow-hidden', className)}
        breakpoints={{
          640: {
            slidesPerView: 2,
            effect: 'none',
            centeredSlides: false,
          },
          1024: {
            slidesPerView: 3,
            effect: 'none',
            centeredSlides: false,
          },
          1250: {
            slidesPerView: slidesPerView,
            effect: 'none',
            centeredSlides: false,
          },
        }}
      >
        {children.map((child, index) => (
          <SwiperSlide key={index}>{child}</SwiperSlide>
        ))}
      </SwiperComponent>
    </div>
  );
}